import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=21d4fd1c&scoped=true&"
import script from "./addproduct.vue?vue&type=script&lang=js&"
export * from "./addproduct.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addproduct.vue?vue&type=style&index=1&id=21d4fd1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d4fd1c",
  null
  
)

export default component.exports